import React, { useCallback, useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { StyledFilterWrapper } from 'molecules/Filter/Filter.styles';
import { FilterAutocomplete } from 'atoms/TableFilter';
import { StyledPaper } from 'pages/ContactsPage/Contacts.styles';
import { debounce } from 'lodash-es';
import axios, { AxiosResponse } from 'axios';
import ExpenseTable, { ExpenseRow } from 'organisms/ExpenseTable';

const Expense = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<{
    expenses: ExpenseRow[];
    total: number;
  }>({ expenses: [], total: 0 });

  const [search, setSearch] = useState<string | undefined>('');

  /** debounce handler for two types: textfield and autocomplete */
  const debouncedChangeHandler = useCallback(
    debounce((event, value) => {
      setSearch(value || event?.target?.value || '');
    }, 1000),
    []
  );

  useEffect(() => {
    fetchPageData({
      page: 1,
      limit: 20,
      sort_by: 'project_name',
      sort_order: 'desc',
    });
  }, [search]);

  const fetchPageData = async (pagination: {
    page: number;
    limit: number;
    sort_by: string;
    sort_order: string;
  }) => {
    try {
      setLoading(true);
      const response: AxiosResponse<{
        expenses: ExpenseRow[];
        total: number;
      }> = await axios.get(`${process.env.REACT_APP_USER_SERVICE}/expenses`, {
        params: {
          ...prepareParams(),
          page: pagination.page || 1,
          per_page: pagination.limit || 20,
          sort_by: pagination.sort_by || 'project_name',
          sort_order: pagination.sort_order || 'desc',
        },
      });

      setData(response?.data || { expenses: [], total: 0 });
      return response?.data || { expenses: [], total: 0 };
    } catch (e) {
      // eslint-disable-next-line
      console.error(e);
      setData({ expenses: [], total: 0 });
      return { expenses: [], total: 0 };
    } finally {
      setLoading(false);
    }
  };

  function prepareParams() {
    return {
      ...(search?.trim() ? { search } : {}),
    };
  }

  return (
    <StyledPaper>
      <StyledFilterWrapper>
        <Stack direction="row" gap={3} flexWrap="wrap" py="20px">
          <FilterAutocomplete
            isFreeSolo={!!search}
            value={search}
            options={[]}
            placeholder="Search by: Company name, Project name, Expense name"
            tooltip="Search by: Company name, Project name, Expense name"
            onChange={debouncedChangeHandler}
            onReset={() => setSearch('')}
          />
        </Stack>
      </StyledFilterWrapper>

      <ExpenseTable loading={loading} data={data} onChange={fetchPageData} />
    </StyledPaper>
  );
};

export default Expense;
